<template>
  <div>
    <nav-bar />
    <div class="zxlc_box">
      <div class="top">
        <h3>{{ showZXLC }}</h3>
        <div class="router_btn">
          <van-cell is-link @click="showPopup">更多装修阶段</van-cell>
          <van-popup
            v-model="show"
            position="right"
            :style="{ width: '50%', height: '100%' }"
          >
            <van-collapse v-model="activeNames">
              <van-collapse-item title="装修前" name="1">
                <ul class="article_list">
                  <li @click="toZxlc('1')">
                    <p>房产</p>
                  </li>
                  <li @click="toZxlc('2')">
                    <p>收房</p>
                  </li>
                  <li @click="toZxlc('3')">
                    <p>设计</p>
                  </li>
                  <li @click="toZxlc('4')">
                    <p>预算</p>
                  </li>
                  <li @click="toZxlc('5')">
                    <p>合同</p>
                  </li>
                </ul>
              </van-collapse-item>
              <van-collapse-item title="装修中" name="2">
                <ul class="article_list">
                  <li @click="toZxlc('6')">
                    <p>拆改</p>
                  </li>
                  <li @click="toZxlc('7')">
                    <p>水电</p>
                  </li>
                  <li @click="toZxlc('8')">
                    <p>防水</p>
                  </li>
                  <li @click="toZxlc('9')">
                    <p>泥瓦</p>
                  </li>
                  <li @click="toZxlc('10')">
                    <p>木工</p>
                  </li>
                  <li @click="toZxlc('11')">
                    <p>油漆</p>
                  </li>
                  <li @click="toZxlc('12')">
                    <p>安装</p>
                  </li>
                </ul>
              </van-collapse-item>
              <van-collapse-item title="装修后" name="3">
                <ul class="article_list">
                  <li @click="toZxlc('13')">
                    <p>清洁</p>
                  </li>
                  <li @click="toZxlc('14')">
                    <p>家电</p>
                  </li>
                  <li @click="toZxlc('15')">
                    <p>软装</p>
                  </li>
                  <li @click="toZxlc('16')">
                    <p>入住</p>
                  </li>
                </ul>
              </van-collapse-item>
            </van-collapse>
          </van-popup>
        </div>
      </div>
      <div class="zxlc_main">
        <Article
          :article_item="item"
          v-for="item in article_list"
          :key="item.id"
        />
      </div>
      <van-pagination
        v-model="currentPage"
        :total-items="zxlcs"
        :items-per-page="12"
        mode="simple"
        @change="page()"
      />
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/common/Navbar.vue";
import Article from "../components/common/Article.vue";

export default {
  name: "",
  components: { NavBar, Article },
  props: {},
  data() {
    return {
      show: false,
      activeNames: ["1"],
      showZXLC: "",
      article_list: [],
      currentPage: 1,
      zxlcs: ""
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getZxlc();
  },
  mounted() {},
  methods: {
    showPopup() {
      this.show = true;
    },
    toZxlc(e) {
      this.$router.push({ path: `/zxlc/${e}`, query: { e } });
      this.$router.go(0);
    },
    async getZxlc() {
      let e = this.$route.query.e;
      if (e == "1") {
        this.showZXLC = "装修前-房产";
      }
      if (e == "2") {
        this.showZXLC = "装修前-收房";
      }
      if (e == "3") {
        this.showZXLC = "装修前-设计";
      }
      if (e == "4") {
        this.showZXLC = "装修前-预算";
      }
      if (e == "5") {
        this.showZXLC = "装修前-合同";
      }
      if (e == "6") {
        this.showZXLC = "装修中-拆改";
      }
      if (e == "7") {
        this.showZXLC = "装修中-水电";
      }
      if (e == "8") {
        this.showZXLC = "装修中-防水";
      }
      if (e == "9") {
        this.showZXLC = "装修中-泥瓦";
      }
      if (e == "10") {
        this.showZXLC = "装修中-木工";
      }
      if (e == "13") {
        this.showZXLC = "装修后-清洁";
      }
      if (e == "14") {
        this.showZXLC = "装修后-家电";
      }
      if (e == "15") {
        this.showZXLC = "装修后-软装";
      }
      if (e == "16") {
        this.showZXLC = "装修后-入住";
      }

      console.log(e);
      const res = await this.$http.get("/home/api/getngl?id=" + e);
      console.log(res.data);
      this.zxlcs = res.data.length;
      this.article_list.splice(0, this.article_list.length);
      var articleItem = "";
      for (var i = 0; i < res.data.length; i++) {
        articleItem = {
          pic: res.data[i].cover,
          name: res.data[i].messageTitle,
          span: res.data[i].messageBrief,
          id: res.data[i].id
        };
        this.article_list.push(articleItem);
      }
    },
    async page() {
      console.log(this.currentPage);
    }
  }
};
</script>

<style scoped lang="scss">
.zxlc_box {
  margin-top: 48px;
  .top {
    background-color: #fff;
    padding: 10px;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3 {
      margin: 0;
      font-size: 16px;
    }
    .router_btn {
      .van-cell__value {
        font-size: 12px;
        padding: 2px 10px;
        color: #000;
        background-color: #ffe001;
        border-radius: 20px;
      }
    }
  }
}
.zxlc_main {
  padding: 0 10px;
  background-color: #fff;
}
.van-cell--clickable {
  padding: 0;
}
.van-cell::after {
  border: 0;
}
.van-cell__right-icon {
  display: none;
}
</style>
